module.exports = __webpack_public_path__ + "static/media/20170806_49day_2385AT.283e1815.jpg";